export interface AddressValue {
  line1: string;
  line2?: string;
  city: string;
  state?: string;
  province?: string;
  postalCode?: string;
  country: string;
}

export interface NameValue {
  first: string;
  middle?: string;
  last: string;
  suffix?: string;
}

export interface DocumentUploadValue {
  uploadedFileIds: string[];
}

export type AnswerValue =
  | {
      type: 'text';
      value: string;
    }
  | {
      type: 'boolean';
      value: boolean;
    }
  | {
      type: 'date';
      value: string;
    }
  | {
      type: 'number';
      value: number;
    }
  | {
      type: 'select';
      value: string;
    }
  | {
      type: 'multi_select';
      value: string[];
    }
  | {
      type: 'address';
      value: AddressValue;
    }
  | {
      type: 'name';
      value: NameValue;
    }
  | {
      type: 'document_upload';
      value: DocumentUploadValue;
    };

export const isAnswerPresent = (value?: AnswerValue): boolean => {
  if (!value) {
    return false;
  }

  switch (value.type) {
    case 'text':
    case 'date':
    case 'select':
      return value.value.trim().length > 0;

    case 'multi_select':
      return value.value.length > 0;

    case 'boolean':
    case 'number':
      return true;

    case 'address':
      return [value.value.line1, value.value.city, value.value.country].every(
        part => part.trim().length > 0,
      );

    case 'name':
      return [value.value.first, value.value.last].every(
        part => part.trim().length > 0,
      );

    case 'document_upload':
      return value.value.uploadedFileIds.length > 0;
  }
};
